<template>
    <a-modal
        :visible="visible"
        title="Kural Test Et"
        width="700px"
        @cancel="onCancel"
        :footer="null"
        :bodyStyle="{ padding: '24px' }"
    >
        <div class="rule-tester">
            <div class="tester-header">
                <p class="description">
                    Kuralınızın kaç kişi ile eşleşeceğini test edebilirsiniz
                </p>
            </div>

            <div class="tester-body">
                <div class="rule-selector">
                    <label>Kural Seçin</label>
                    <a-select
                        v-model="selectedRuleId"
                        placeholder="Test edilecek kuralı seçin"
                        style="width: 100%;"
                    >
                        <a-select-option
                            v-for="rule in rules"
                            :key="rule.id"
                            :value="rule.id"
                        >
                            {{ rule.name }}
                        </a-select-option>
                    </a-select>
                </div>

                <div class="test-action">
                    <a-button
                        type="primary"
                        size="large"
                        :loading="testing"
                        :disabled="!selectedRuleId"
                        @click="runTest"
                        block
                    >
                        <i class="material-icons">play_arrow</i>
                        Test Et
                    </a-button>
                </div>

                <!-- Test Results -->
                <div v-if="testResult" class="test-results">
                    <a-alert
                        message="Kural Bilgileri"
                        type="info"
                        show-icon
                    >
                        <template slot="description">
                            <div class="rule-info">
                                <div><strong>Ne Zaman:</strong> {{ testResult.info.when === 'contact_created' ? 'Müşteri Kartı Oluştuğunda' : 'Chat Açıldığında' }}</div>
                                <div><strong>Koşul Sayısı:</strong> {{ testResult.info.conditionCount }}</div>
                                <div><strong>Aksiyon Sayısı:</strong> {{ testResult.info.actionCount }}</div>
                            </div>
                        </template>
                    </a-alert>
                </div>
            </div>
        </div>
    </a-modal>
</template>

<script>
import { mapState } from "vuex";
import log2 from "../../../../../utils/log2";

const log = log2("RuleTester");

export default {
    name: "RuleTester",
    props: {
        visible: {
            type: Boolean,
            required: true
        }
    },
    data() {
        return {
            selectedRuleId: null,
            testing: false,
            testResult: null
        };
    },
    computed: {
        ...mapState({
            settings: state => state.setting.settings
        }),
        rules() {
            return this.settings.contactModuleRules?.rules || [];
        }
    },
    methods: {
        onCancel() {
            this.$emit("close");
        },

        async runTest() {
            if (!this.selectedRuleId) return;

            this.testing = true;
            this.testResult = null;

            try {
                // Frontend'de basit bir test - backend'e istek atmadan sadece bilgi ver
                const rule = this.rules.find(r => r.id === this.selectedRuleId);
                if (!rule) {
                    this.$message.warning("Kural bulunamadı");
                    return;
                }

                const conditionCount = this.getConditionCount(rule.conditions);
                const actionCount = rule.actions?.length || 0;

                this.testResult = {
                    matchCount: "?",
                    totalTested: "?",
                    matchedContacts: [],
                    info: {
                        conditionCount,
                        actionCount,
                        when: rule.when
                    }
                };

                this.$message.info("Test özelliği yakında eklenecek. Şu an sadece kural bilgilerini görebilirsiniz.");
                log("Test info", { rule });
            } catch (error) {
                log("Test error", error);
                this.$message.error("Test sırasında hata oluştu");
            } finally {
                this.testing = false;
            }
        },

        getConditionCount(conditions) {
            if (!conditions || !conditions.filterGroups) return 0;
            return conditions.filterGroups.reduce((count, group) => {
                return count + (group.filters ? group.filters.length : 0);
            }, 0);
        }
    }
};
</script>

<style lang="scss" scoped>
.rule-tester {
    .tester-header {
        .description {
            color: #666;
            margin-bottom: 24px;
            padding: 12px;
            background: #f5f5f5;
            border-left: 3px solid #1890ff;
            border-radius: 4px;
        }
    }

    .tester-body {
        .rule-selector {
            margin-bottom: 24px;

            label {
                display: block;
                font-weight: 600;
                margin-bottom: 8px;
                color: #1a1a1a;
            }
        }

        .test-action {
            margin-bottom: 24px;

            button {
                height: 48px;
                font-size: 16px;
                font-weight: 600;

                .material-icons {
                    font-size: 20px;
                    margin-right: 8px;
                    vertical-align: middle;
                }
            }
        }

        .test-results {
            .ant-alert {
                margin-bottom: 24px;
            }

            .rule-info {
                display: flex;
                flex-direction: column;
                gap: 8px;
                margin-top: 8px;

                div {
                    font-size: 14px;

                    strong {
                        margin-right: 8px;
                    }
                }
            }
        }
    }
}
</style>

